import script from "./PayrollTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollTableRow.vue?vue&type=script&setup=true&lang=js"

import "./PayrollTableRow.vue?vue&type=style&index=0&id=11752ecb&lang=css"

const __exports__ = script;

export default __exports__